import { render, staticRenderFns } from "./SurfTabs.vue?vue&type=template&id=04d32a6e&scoped=true"
import script from "./SurfTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./SurfTabs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SurfTabs.vue?vue&type=style&index=0&id=04d32a6e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d32a6e",
  null
  
)

export default component.exports